"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenSchema = exports.SiteSchema = exports.SiteDetailSchema = exports.ProductSecurityCodeSchema = exports.ProductSecurityCodeDetailSchema = exports.securityCodeType = exports.ProductSchema = exports.ProductDetailsSchema = exports.ProductPromotionSchema = exports.ProductPromotionDetailSchema = exports.AnimalPromotionSchema = exports.AnimalPromotionDetailSchema = exports.PlantSchema = exports.PlantDetailsSchema = exports.AssetProfileSchema = exports.AssetProfileDetailSchema = exports.AngusCalveDetailsSchema = exports.AngusSireGroupDetailsSchema = exports.AngusMobDetailsSchema = exports.AngusSireSchema = exports.AngusSireDetailsSchema = exports.GroupDetailsSchema = exports.BrandSchema = exports.BrandDetailsSchema = exports.SireDetailsSchema = exports.ConsigneeDetailsSchema = exports.ConsignmentDetailsSchema = exports.AssetDetailsSchema = exports.BusinessDetailsSchema = exports.UserDetailsSchema = exports.TokenGeneralSchema = void 0;
const zod_1 = require("zod");
const TokenMisc = __importStar(require("../misc/token"));
const AssetMisc = __importStar(require("../misc/asset"));
const BusinessMisc = __importStar(require("../misc/business"));
const GroupMisc = __importStar(require("../misc/group"));
const BrandMisc = __importStar(require("../misc/brand"));
const PromotionMisc = __importStar(require("../misc/promotion"));
const ProductMisc = __importStar(require("../misc/product"));
const SiteMisc = __importStar(require("../misc/site"));
const UserMisc = __importStar(require("../misc/user"));
const AngusCalveMisc = __importStar(require("../misc/angusCalve"));
const AngusMobMisc = __importStar(require("../misc/angusMob"));
const AngusSireMisc = __importStar(require("../misc/angusSire"));
const AssetProfileMisc = __importStar(require("../misc/assetProfile"));
const LocationMisc = __importStar(require("../misc/location"));
const ConsignmentMisc = __importStar(require("../misc/consignment"));
const credential_1 = require("../misc/credential");
//Utils
exports.TokenGeneralSchema = zod_1.z.object({
    externalIds: zod_1.z.array(TokenMisc.ExternalIdsSchema),
    status: zod_1.z.array(zod_1.z.string()),
    userId: zod_1.z.string(),
    hash: zod_1.z.string(),
    activities: zod_1.z.array(zod_1.z.object({
        type: zod_1.z.string(),
        uuid: zod_1.z.string(),
        collection: zod_1.z.string(),
    })),
    createdAt: zod_1.z.date(),
    tokenId: zod_1.z.string().optional(),
    contractAddress: zod_1.z.string().optional(),
    walletAddress: zod_1.z.string().optional(),
    businessId: zod_1.z.string().optional(),
    metadata: LocationMisc.locationDataSchema.optional()
});
// User
exports.UserDetailsSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.user),
    details: UserMisc.UserDetailSchema
});
const UserSchema = exports.UserDetailsSchema.merge(exports.TokenGeneralSchema);
// Business
const PluginSubscriptionSchema = zod_1.z.union([credential_1.PluginCredentialSchema, credential_1.PluginBusinessCredentialSchema]);
exports.BusinessDetailsSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.business),
    details: BusinessMisc.GeneralBusinessDetailSchema,
    plugins: zod_1.z.array(PluginSubscriptionSchema).optional()
});
const BusinessSchema = exports.BusinessDetailsSchema.merge(exports.TokenGeneralSchema);
// Asset
exports.AssetDetailsSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.asset),
    details: AssetMisc.AssetDetailSchema
});
const AssetSchema = exports.AssetDetailsSchema.merge(exports.TokenGeneralSchema);
// Item
// export const ItemDetailsSchema = z.object({
//   type: z.literal(TokenMisc.tokenTypesSchema.enum.item),
//   details: z.object({
//     product: ExternalIdsSchema,
//     batchId: z.string(),
//     container: z.string(),
//     date: z.string(),
//     source: z.string(),
//     externalIds: ExternalIdsSchema,
//   })
// })
// const ItemSchema = ItemDetailsSchema.merge(TokenGeneralSchema)
// export type Item = z.infer<typeof ItemSchema>
// Consignment
exports.ConsignmentDetailsSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.consignment),
    details: ConsignmentMisc.ConsignmentDetailSchema
});
const ConsignmentSchema = exports.TokenGeneralSchema.merge(exports.ConsignmentDetailsSchema).merge(zod_1.z.object({
    status: zod_1.z.array(zod_1.z.enum(["draft", "submitted", "completed", "transferring", "transferred"]))
}));
// Consignee
exports.ConsigneeDetailsSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.consignee),
    details: TokenMisc.ConsigneeDetailSchema
});
const ConsigneeSchema = exports.ConsigneeDetailsSchema.merge(exports.TokenGeneralSchema);
// Sire
exports.SireDetailsSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.sire),
    details: TokenMisc.SireDetailSchema
});
const SireSchema = exports.SireDetailsSchema.merge(exports.TokenGeneralSchema);
// Brand
exports.BrandDetailsSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.brand),
    details: BrandMisc.BrandDetailSchema
});
exports.BrandSchema = exports.BrandDetailsSchema.merge(exports.TokenGeneralSchema);
// Group
exports.GroupDetailsSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.group),
    details: GroupMisc.GroupDetailSchema
});
const GroupSchema = exports.GroupDetailsSchema.merge(exports.TokenGeneralSchema);
// AngusSire
exports.AngusSireDetailsSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.angusSire),
    details: AngusSireMisc.AngusSireDetailSchema
});
exports.AngusSireSchema = exports.AngusSireDetailsSchema.merge(exports.TokenGeneralSchema);
// AngusMob
exports.AngusMobDetailsSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.angusMob),
    details: AngusMobMisc.AngusMobDetailSchema
});
const AngusMobSchema = exports.AngusMobDetailsSchema.merge(exports.TokenGeneralSchema);
// AngusSireGroup
exports.AngusSireGroupDetailsSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.angusSireGroup),
    details: AngusSireMisc.AngusSireGroupDetailSchema
});
const AngusSireGroupSchema = exports.AngusSireGroupDetailsSchema.merge(exports.TokenGeneralSchema);
// AngusCalve
exports.AngusCalveDetailsSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.angusCalve),
    details: AngusCalveMisc.AngusCalveDetailSchema
});
const AngusCalveSchema = exports.AngusCalveDetailsSchema.merge(exports.TokenGeneralSchema);
// Asset Profile
exports.AssetProfileDetailSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.assetProfile),
    details: AssetProfileMisc.AssetProfileDetailSchema,
});
exports.AssetProfileSchema = exports.AssetProfileDetailSchema.merge(exports.TokenGeneralSchema);
//Plant
exports.PlantDetailsSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.plant),
    details: TokenMisc.PlantDetailsSchema
});
exports.PlantSchema = exports.PlantDetailsSchema.merge(exports.TokenGeneralSchema);
//Promotion Token
exports.AnimalPromotionDetailSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.promotion),
    details: PromotionMisc.AnimalPromotionSchema
});
exports.AnimalPromotionSchema = exports.AnimalPromotionDetailSchema.merge(exports.TokenGeneralSchema);
exports.ProductPromotionDetailSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.promotion),
    details: PromotionMisc.ProductPromotionSchema
});
exports.ProductPromotionSchema = exports.ProductPromotionDetailSchema.merge(exports.TokenGeneralSchema);
//Product Token
exports.ProductDetailsSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.product),
    details: ProductMisc.ProductDetailSchema
});
exports.ProductSchema = exports.ProductDetailsSchema.merge(exports.TokenGeneralSchema);
//Security Code Token
exports.securityCodeType = zod_1.z.enum(['item', 'carton', 'pallet']);
exports.ProductSecurityCodeDetailSchema = zod_1.z.object({
    type: exports.securityCodeType,
    details: TokenMisc.ProductSecurityCodeDetailSchema
});
exports.ProductSecurityCodeSchema = exports.ProductSecurityCodeDetailSchema.merge(exports.TokenGeneralSchema);
//Site Token
exports.SiteDetailSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.site),
    details: SiteMisc.SiteDetailSchema
});
exports.SiteSchema = exports.SiteDetailSchema.merge(exports.TokenGeneralSchema);
//Token
exports.TokenSchema = zod_1.z.union([
    UserSchema,
    BusinessSchema,
    AssetSchema,
    ConsignmentSchema,
    ConsigneeSchema,
    SireSchema,
    exports.BrandSchema,
    GroupSchema,
    exports.AngusSireSchema,
    AngusMobSchema,
    AngusSireGroupSchema,
    AngusCalveSchema,
    exports.AssetProfileSchema,
    exports.PlantSchema,
    exports.AnimalPromotionSchema,
    exports.ProductSchema,
    exports.ProductSecurityCodeSchema,
    exports.SiteSchema
]);
